export default "__VITE_ASSET__DZ1CXdaJ__"